import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { CollaboratorsTypes, CollaboratorInterface } from './types';

// List Collaborators
export const listCollaboratorsRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(CollaboratorsTypes.LIST_COLLABORATORS_REQUEST, payload);
export const listCollaboratorsSuccess = (payload: {
  collaboratorsList: CollaboratorInterface[];
  totalCount: number;
}) => action(CollaboratorsTypes.LIST_COLLABORATORS_SUCCESS, payload);
export const listCollaboratorsFailure = () =>
  action(CollaboratorsTypes.LIST_COLLABORATORS_FAILURE);

// Get Collaborator
export const getCollaboratorRequest = (payload: object) =>
  action(CollaboratorsTypes.GET_COLLABORATOR_REQUEST, payload);
export const getCollaboratorSuccess = (payload: {
  collaboratorData: CollaboratorInterface;
}) => action(CollaboratorsTypes.GET_COLLABORATOR_SUCCESS, payload);
export const getCollaboratorFailure = () =>
  action(CollaboratorsTypes.GET_COLLABORATOR_FAILURE);

// Filter Collaborators
export const filterCollaboratorsRequest = (payload: object) =>
  action(CollaboratorsTypes.FILTER_COLLABORATORS_REQUEST, payload);
export const filterCollaboratorsSuccess = (payload: {
  collaboratorsList: CollaboratorInterface[];
  totalCount: number;
}) => action(CollaboratorsTypes.FILTER_COLLABORATORS_SUCCESS, payload);
export const filterCollaboratorsFailure = () =>
  action(CollaboratorsTypes.FILTER_COLLABORATORS_FAILURE);

// Create Collaborator
export const createCollaboratorRequest = (payload: {
  name: string;
  email?: string;
  phone?: string;
  document: string;
  companyId?: string;
}) => action(CollaboratorsTypes.CREATE_COLLABORATOR_REQUEST, payload);
export const createCollaboratorSuccess = () =>
  action(CollaboratorsTypes.CREATE_COLLABORATOR_SUCCESS);
export const createCollaboratorFailure = () =>
  action(CollaboratorsTypes.CREATE_COLLABORATOR_FAILURE);

// Link Collaborator to Company
export const linkCollaboratorToCompanyRequest = (payload: {
  users: Array<{
    id: string;
  }>;
  authUserId: string;
}) => action(CollaboratorsTypes.LINK_COLLABORATOR_TO_COMPANY_REQUEST, payload);
export const linkCollaboratorToCompanySuccess = (payload: {
  linkCollaboratorCompanyData: any;
}) => action(CollaboratorsTypes.LINK_COLLABORATOR_TO_COMPANY_SUCCESS, payload);
export const linkCollaboratorToCompanyFailure = () =>
  action(CollaboratorsTypes.LINK_COLLABORATOR_TO_COMPANY_FAILURE);

// Unlink Collaborator from Company
export const unlinkCollaboratorFromCompanyRequest = (payload: {
  users: Array<{
    id: string;
  }>;
  authUserId: string;
}) =>
  action(CollaboratorsTypes.UNLINK_COLLABORATOR_FROM_COMPANY_REQUEST, payload);
export const unlinkCollaboratorFromCompanySuccess = (payload: {
  unlinkCollaboratorCompanyData: any;
}) =>
  action(CollaboratorsTypes.UNLINK_COLLABORATOR_FROM_COMPANY_SUCCESS, payload);
export const unlinkCollaboratorFromCompanyFailure = () =>
  action(CollaboratorsTypes.UNLINK_COLLABORATOR_FROM_COMPANY_FAILURE);

// Update Collaborator
export const updateCollaboratorRequest = (payload: object) =>
  action(CollaboratorsTypes.UPDATE_COLLABORATOR_REQUEST, payload);
export const updateCollaboratorSuccess = () =>
  action(CollaboratorsTypes.UPDATE_COLLABORATOR_SUCCESS);
export const updateCollaboratorFailure = () =>
  action(CollaboratorsTypes.UPDATE_COLLABORATOR_FAILURE);

// Delete Collaborator
export const deleteCollaboratorRequest = (payload: {
  id: Array<string> | string;
}) => action(CollaboratorsTypes.DELETE_COLLABORATOR_REQUEST, payload);
export const deleteCollaboratorSuccess = () =>
  action(CollaboratorsTypes.DELETE_COLLABORATOR_SUCCESS);
export const deleteCollaboratorFailure = () =>
  action(CollaboratorsTypes.DELETE_COLLABORATOR_FAILURE);

// Create Collaborators
export const createCollaboratorsRequest = (payload: Array<object>) =>
  action(CollaboratorsTypes.CREATE_COLLABORATORS_REQUEST, payload);
export const createCollaboratorsSuccess = () =>
  action(CollaboratorsTypes.CREATE_COLLABORATORS_SUCCESS);
export const createCollaboratorsFailure = () =>
  action(CollaboratorsTypes.CREATE_COLLABORATORS_FAILURE);

// Update Collaborators
export const updateCollaboratorsRequest = (payload: object) =>
  action(CollaboratorsTypes.UPDATE_COLLABORATORS_REQUEST, payload);
export const updateCollaboratorsSuccess = () =>
  action(CollaboratorsTypes.UPDATE_COLLABORATORS_SUCCESS);
export const updateCollaboratorsFailure = () =>
  action(CollaboratorsTypes.UPDATE_COLLABORATORS_FAILURE);

// Delete Collaborators
export const deleteCollaboratorsRequest = (payload: object) =>
  action(CollaboratorsTypes.DELETE_COLLABORATORS_REQUEST, payload);
export const deleteCollaboratorsSuccess = () =>
  action(CollaboratorsTypes.DELETE_COLLABORATORS_SUCCESS);
export const deleteCollaboratorsFailure = () =>
  action(CollaboratorsTypes.DELETE_COLLABORATORS_FAILURE);
